import { render, staticRenderFns } from "./expenseApproval.vue?vue&type=template&id=57cdd44f&scoped=true"
import script from "./expenseApproval.vue?vue&type=script&lang=js"
export * from "./expenseApproval.vue?vue&type=script&lang=js"
import style0 from "./expenseApproval.vue?vue&type=style&index=0&id=57cdd44f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdd44f",
  null
  
)

export default component.exports